<template>
    <div>
      <label :for="id">
        <div class="ipt-container" :class="{'has-drop': dropdownList, 'focus': !empty}">
          <span class="placeholder lighter-gray-txt">{{placeholder}}</span>
          <el-input
            :id="id"
            :type="type || 'text'"
            @blur="blur()"
            @focus="focusIpt()"
            :disabled="disabled"
            v-if="readonly !== true && !auto"
            class="model"
            v-ipt-focus="{focus: focus}"
            v-model="object[model]"
            auto-complete="off"
            :name="model"
            @input="input()"
          >
            <template v-if="append && showOneKey && append=='一键获取'" slot="append">
                <el-popover
                  placement="top-start"
                  width="150"
                  trigger="hover"
                  content="点击下载商品图片规格等信息.">
                  <el-button slot="reference" @click="onekeySubmit()">
                    <img src="../ico/download.png" alt="">
                  </el-button>
                </el-popover>
            </template>
            <template v-if="append && append!='一键获取'" slot="append">{{append}}</template>
          </el-input>
          <el-input
            :id="id"
            :type="type || 'text'"
            @blur="blur()"
            @focus="focusIpt()"
            :disabled="disabled"
            v-if="readonly !== true && auto"
            class="model"
            v-ipt-focus="{focus: focus}"
            v-model="object[model]"
            auto-complete="off"
            :name="model"
            @keyup.native="input()"
          >
            <template v-if="append && showOneKey && append=='一键获取'" slot="append">
              <el-popover
                  placement="top-start"
                  width="150"
                  trigger="hover"
                  content="点击下载商品图片规格等信息.">
                  <el-button slot="reference" @click="onekeySubmit()">{{append}}</el-button>
                </el-popover>
            </template>
            <template v-if="append && append!='一键获取'" slot="append">{{append}}</template>
          </el-input>
          <el-input
            :type="type || 'text'"
            v-if="readonly === true"
            :disabled="disabled"
            :readonly="readonly"
            class="model"
            v-model.trim="content"
            auto-complete="off"
            :name="model"
            @input="input()"
          >
            <template v-if="append && showOneKey && append=='一键获取'" slot="append">
              <el-popover
                  placement="top-start"
                  width="150"
                  trigger="hover"
                  content="点击下载商品图片规格等信息.">
                  <el-button slot="reference"  @click="onekeySubmit()">{{append}}</el-button>
                </el-popover>
            </template>
            <template v-if="append && append!='一键获取'" slot="append">{{append}}</template>
          </el-input>
          <el-dropdown trigger="click" class="ipt-dropdown" v-if="dropdownList" @command="handleCommand">
            <span class="el-dropdown-link">
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="item" v-for="(item,index) in dropdownList" :key="index">{{item.value}}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <slot></slot>
        </div>
      </label>
    </div>
</template>

<script>
export default {
  name: 'YueDanIpt',
  props: [
    'placeholder', 'model', 'object', 'append',
    'disabled', 'readonly', 'focus', 'dropdownList',
    'type', 'reg','auto','showOneKey', 'subModel','noneedempty'
  ],
  components: {
  },
  data () {
    return {
      empty: true,
      id: null,
      matchVal: null,
    }
  },
  computed: {
    content () {
      if (this.readonly) {
        if (this.subModel) {
          const temp = Number(this.object[this.subModel])
          return `${this.object[this.model]}${(temp && temp !== '0') ? ' + ' + temp : ''}`
        } else {
          return this.object[this.model]
        }
      }
    }
  },
  created() {
    this.id = 'ipt' + Math.floor(Math.random()*1000000)
    this.matchVal = this.object[this.model]
  },
  methods: {
    focusIpt() {
      this.$emit('focusIpt')
    },
    submit () {
    },
    blur () {
      setTimeout(() => {
        if(this.model !='old_password' && this.model !='new_password'){
          if(this.object[this.model]){
            this.object[this.model]=this.object[this.model].replace(/(^\s*)|(\s*$)/g,'')
          }
        }
        if (document.getElementById(this.id)) {
          document.getElementById(this.id).value = this.object[this.model]||''
        }
      })
      this.$emit('blur', this.object[this.model])
    },
    handleCommand (command) {
      setTimeout(() => {
        if (document.getElementById(this.id)) {
          document.getElementById(this.id).value = this.object[this.model]
        }
      })
      this.$emit('dropdownChange', command)
    },
    analysis(){
      this.$emit('analysisAddress')
    },
    input () {
      if (this.auto || this.append=='一键获取') {
        this.$emit('input', this.object[this.model])
      }
      if (!this.reg) {
        return
      }
      if (!this.object[this.model]) {
        this.matchVal = null
        return
      }
      this.matchVal = this.object[this.model].match(this.reg)? this.object[this.model].match(this.reg)[0]: this.matchVal
      this.object[this.model] = this.matchVal
      setTimeout(() => {
        document.getElementById(this.id).value = this.matchVal
      })
      this.$forceUpdate()
      this.$emit('input', this.matchVal)
    },
    onekeySubmit () {
      this.$emit('oneKeySuccess')
    }
  },
  watch:{
    object: {
      handler: function (val, oldVal) {
        if (this.object[this.model]) {
          this.empty = false
        } else {
          this.empty = true
        }
      },
      deep: true
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.ipt-dropdown {
  position: absolute;
  top: 5px;
  right: 3px;
  cursor: pointer;
}
</style>

<style lang="scss">
.ipt-container {
  &.has-drop {
    .el-input-group__append {
      padding-right: 18px;
    }
  }
}
.ipt-container {
  margin-top: 15px;
  position: relative;
  height: 50px;

  &.group {
    margin-top: 0;
    & > .el-input {
      input {
        border-radius: 0 0 0 0;
      }
    }
    &:first-child > .el-input {
      input {
        border-radius: 4px 4px 0 0;
      }
    }
    &:last-child > .el-input {
      input {
        border-radius: 0 0 4px 4px;
      }
    }
  }

  &:first-child {
    margin-top: 0;
  }

  .placeholder {
    position: absolute;
    top:0;
    left: 12px;
    height: 50px;
    line-height: 50px;
    transition: all 150ms linear;
    z-index: 100;
  }

  &.focus {
    & > .placeholder {
      height: 20px;
      line-height: 20px;
      font-size: 10px;
      top: 5px;
    }
  }

  input {
    position: relative;
    z-index: 99;
    height: 50px;
    border: 1px solid #C6C9CB;
    width: 100%;
    display: block;
    font-size: 14px;
    padding: 18px 10px 2px 10px;
    line-height: 28px;
    background: transparent;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/YueDanIptEx.vue